// tslint:disable: quotemark max-line-length

import countryList from '~common/app/i18n/countries-en';

export const english = {

  // Auth

  "auth": {
    "login": {
      "heading": "Sign In to your account",
      "heading.sso": "Single Sign-on",
      "forgot-password": "Forget your password?",
      "remember-me": "Remember me",
      "button.login": "Sign In",
      "form.error": "Wrong Username or password.",
      "signup": "No account yet? Sign Up!",
      "login-sso": "SSO Login",
      "login-back": "Regular login",
      "weak-password":
        `Your password is not strong enough.
 Please change it to secure your account.`
    },
    "signup": {
      "heading": "Sign Up for an account",
      "button.login": "Sign Up",
      "form.error": "An error occurs.",
      "form.success": "An email has been sent.",
      "signin": "Already have an account? Sign In!",
      "hint": "An email with instruction will be sent.",
    }
  },

  // Onboarding

  "onboarding": {
    "company_number": {
      "heading": "Do you know your Company number?",
      "heading.shop": "Shop detail",
      "label": "My Company number is:",
      "button.search": "Search by Company number",
      "sidebar": {
        "marketplace": "Marketplace",
        "gifts": "Gifts",
        "heading": "We‘re glad you're taking this step!",
        "text": "First, we‘ll need to get a little information about your point of sales.",
        "help1.heading": "You have more then one point of sales?",
        "help1.text": "Don‘t worry, you will be able to add it later!",
      }
    },
    "tos": {
      "heading": "Terms of Service",
      "scrolldown": "Scroll down down to accept TOS",
      "accept1": "I‘ve read all the contract above",
      "accept2": "I declare that I accept the terms of this document"
    }
  },

  // Dashboards

  "dashboard": {
    "main": {
      "tab": {
        "offer": "Offer",
        "cardholder": "Cardholder",
        "merchant": "Merchant",
      },
      "heading": "Dashboard",
      "heading.reach": "Reach",
      "heading.turnover": "Turnover",
      "heading.statistics": "Statistics",
      "heading.advertising": "Free advertising",
      "empty": "No data available yet…",
    },
    "charts": {
      "subscribers-evolution": "Subscribers evolution",
      "churners-evolution": "Churners evolution",
      "rewarded-consumers": "Rewarded consumers",
      "reward-amount-commission": "Reward amount + commission",
      "number-of-rewards": "Number of rewards",
      "voucher-discount": "Rewards amount + commission",
      "voucher-by-consumers": "Rewarded consumers",
      "vouchers": "Vouchers",
      "gifts-count": "Number of gifts",
      "gifts-amount": "Gift amount",
      "activated-gifts": "Activated gifts",
      "unique-coupons": "Unique coupons",
      "unique-activated-coupons": "Unique activated coupons",
      "generic-coupons": "Generic coupons",
      "generic-activated-coupons": "Generic activated coupons",
      "lbs-live-merchants": "LBS Number of live Merchants",
      "lbs-churners-merchants": "LBS Number of unregistered merchants",
      "lbs-cashback-reward-amount": "LBS Cashback - Reward amount per month",
      "labels": {
        "subscriptions": "Subscriptions",
        "cumulative-subscriptions": "Cumulative subscriptions",
        "churners": "Churners",
        "cumulative-churners": "Cumulative churners",
        "rewarded": "Rewarded",
        "program-fees": "Commission",
        "reward-amount": "Reward amount",
        "discount": "Discount",
        "fees": "Commission",
        "count": "Count",
        "amount": "Amount",
        "coupons": "Coupons",
        "activated": "Activated",
      },
    },
    "metrics": {
      "total-subscribers": "Total subscribers",
      "total-subscribers-hint": "Total number of sign-ups to the program since the launch",
      "total-churners": "Total churners",
      "total-churners-hint": "Total number of users who have unsubscribed from the program since the launch",
      "total-onboarded": "Total onboarded since launch",
      "total-onboarded-hint": "Total number of users registered in the program to date",
      "total-rewarded": "Total rewarded",
      "total-rewarded-hint": "Total number of users who have generated cashback since the program launch",
      "total-playground": "Total playground",
      "total-playground-hint": "Total revenue amount (cashbacks + commissions) generated since the program launch",
      "total-commission": "Total commission",
      "total-commission-hint": "Total amount of commissions generated since the launch",
      "total-revenue": "Generated revenue",
      "total-revenue-hint": "Total amount of transactions that generated cashback over the observed period",
      "average-basket": "Average basket",
      "average-basket-hint": "Average amount of transactions that generated cashback over the observed period (Generated revenue / Number of rewards)",
      "number-of-rewards": "Number of rewards",
      "number-of-rewards-hint": "Total number of cashbacks generated since the launch",
      "reward-amount": "Reward amount",
      "reward-amount-hint": "Total amount of cashbacks generated since the launch",
      "average-reward-amount": "Average reward",
      "average-reward-amount-hint": "Average amount of a cashback over the observed period (Reward amount / Number of rewards)",
      "total-discounts": "Total discounts",
      "total-discounts-hint": "Total amount of voucher discounts generated since the launch",
      "total-fees": "Total fees",
      "total-fees-hint": "Total amount of fees generated since the launch",
      "total-vouchers": "Total vouchers",
      "total-vouchers-hint": "Total number of vouchers issued over the observed period",
      "total-voucher-value": "Total voucher value",
      "total-voucher-value-hint": "Total face value of vouchers issued over the observed period",
      "total-voucher-sell": "Total voucher sales value",
      "total-voucher-sell-hint": "Total amount paid by consumers to purchase vouchers over the observed period",
      "total-voucher-discount": "Total voucher discount",
      "total-voucher-discount-hint": "Total amount of voucher discounts generated over the observed period",
      "total-voucher-commission": "Total voucher commission",
      "total-voucher-commission-hint": "Total amount of commissions generated on vouchers over the observed period",
      "rewards-per-merchant": "Number of rewards per merchant",
      "reward-amount-per-brand": "Reward amount per brand",
      "average-reward-amount-per-brand": "Average reward amount per brand",
      "commission-per-brand": "Commission per brand",
      "vouchers-per-brand": "Number of vouchers per brand",
      "voucher-discount-per-brand": "Rewards amount per merchant",
      "voucher-commission-per-brand": "Voucher commission per brand",
      "total-gifts": "Total gifts",
      "total-gifts-hint": "Total number of gifts distributed since the launch",
      "total-gifts-amount": "Total gift amount",
      "total-gifts-amount-hint": "Total amount of gifts distributed since the launch",
      "total-activated-gifts": "Total activated gifts since launch",
      "total-activated-gifts-hint": "Total number of gifts activated by users",
      "total-unique-coupons": "Total unique coupons",
      "total-unique-coupons-hint": "Total number of unique coupons created since the launch",
      "total-unique-activated-coupons": "Total unique activated coupons",
      "total-unique-activated-coupons-hint": "Total number of unique coupons activated by users",
      "total-generic-coupons": "Total generic coupons",
      "total-generic-coupons-hint": "Total number of generic coupons created since the launch",
      "total-generic-activated-coupons": "Total generic activated coupons",
      "total-generic-activated-coupons-hint": "Total number of generic coupons activated by users",
    },
    "leaderboard": {
      "count": "Count",
      "amount": "Amount (€)",
      "brand-name": "Brand Name",
      "show-all": "Show all",
      "show-less": "Show less",
    },
  },

  // Marketplace

  "campaigns": {
    "list": {
      "tab": {
        "available": "Available",
        "accepted": "Accepted",
        "rejected": "Rejected",
        "all": "All",
      },
      "heading": "Campaigns",
      "empty": "No strategy available yet…"
    },
    "objectives": {
      "LOYALTY": "Loyalty",
      "AVERAGE_BASKET": "Average basket",
      "MARKET_SHARE": "Market share",
      "OMNICHANNEL": "Omnichannel",
      "ACQUISITION": "Acquisition",
      "CUSTOM": "Custom",
    },
    "details": {
      "heading": "Campaign",
      "heading.offers": "Offers",
      "heading.guidelines": "Guidelines",
      "heading.campaign": "Campaign",
      "heading.targeting": "Targeting",
      "heading.commission-group": "Commission groups",
      "heading.vouchers": "Vouchers",
      "heading.terms": "Terms of Service",
      "button.create": "Create an offer",
      "empty": "You must create an offer from this campaign…",
      "empty-warning": "Add an offer to this campaign will set it to 'Accepted'.",
      "empty-targeting": "This campaign is generic.",
      "lookalike-targeting": "Lookalike audience",
      "specific-targeting": "Specific audience",
      "specific-targeting-hint": "Audience built from a customer list provided by the brand. For more details about this audience, please contact support.",
    },
    "form": {},
    "shared": {
      "channel.ONLINE": "Online",
      "channel.OFFLINE": "In store",
      "channel.BOTH": "Online + In store",
      "dialog.confirm-reject": "Are you sure to reject this campaign?",
      "button.apply-guidelines": "Apply guidelines",
      "only-reward-transactions": "Only reward transactions from {source}",
      "custom-date": "Custom dates",
      "commission-share": "Average commission",
      "form.success.renamed": "Commission successfully renamed.",
      "summary": {
        "heading": "Summary",
        "checklist": {
          "details": "Details",
          "target": "Targeting",
          "terms": "Legal Terms",
          "published": "Published on",
        },
        "current-state": "Current state",
        "remaining-time": "Remaining time",
        "remaining-time-count": "{ nb, plural, =0 {# day} =1 {# day} other {# days} }",
        "remaining-day-left-count": "{ nb, plural, =0 {# day} =1 {# day} other {# days} } left",
        "no-more-budget": "This campaign initial budget of { value } was completely depleted.",
        "no-more-time": "This campaign ended on { date }",
        "published": "Published",
        "publication": "Publication",
        "activation": "Activation",
        "waiting-publication": "Waiting for publication",
        'ended-completed': 'Campaign budget has been used up on the {date}.',
        'ended-deactivated': 'This campaign has been deactivated on the {date}.',
      },
    }
  },

  // Reports

  "reports": {
    "list": {
      "heading": "Reporting",
      "empty": "No result…",
      "empty-results": "No result with these filters…",
      "metrics-reward-amount": "Reward amount",
      "metrics-total-commissions": "Total commissions",
      "metrics-total-consumers": "Total consumers",
      "metrics-total-rewards": "Total rewards",
      "metrics-total-vouchers": "Total vouchers",
      "metrics-voucher-amount": "Voucher amount",
      "metrics-voucher-funds": "Remaining voucher budget",
      "metrics-voucher-revenue": "Total revenues",
    },
    "shared": {
      "brand": "Brand",
      "created-at": "Created",
      "offer-reference": "Offer ref.",
      "consumer-id": "Consumer ID",
      "executed-at": "Executed",
      'strategy-reference': 'Campaign',
      "transaction-amount": "Transaction",
      "reward-rate": "Reward Rate",
      "reward-amount": "Reward",
      "commission": "Commission",
      "campaign": "Campaign",
      "type": "Type",
      "updated-at": "Updated",
      "status": "Status",
      "technical-status": "Technical status",
      "consumer-status": "Consumer status",
      "offer": "Offer",
      "strategy": "Strategy",
      "invoice": "Invoice",
      "original-price": "Price",
      "value": "Value",
      "total-fees": "Fees",
      "paylead-fees": "Paylead Fees",
      "price": "User price",
      "program-fees": "Revenue",
      "only-paid": "Only paid vouchers",
      "only-valid": "Only valid rewards",
      "apply-filters": "Apply filters",
      "reset-filters": "Reset",
      "types": {
        "CASHBACK": "ALO Rewards",
        "CASHBACK_AFFILIATION": "Affiliation Rewards",
        "GIFT": "Gifts",
        "COUPON": "Coupons",
        "VOUCHER": "Vouchers",
        "AWIN": "Awin transactions",
        "LBS_CASHBACK": "Reward LBS",
        "EVO_CASHBACK": "Voucher cashback"
      },
      "tabs": {
        "rewards": "Rewards",
        "vouchers": "Vouchers",
      }
    }
  },

  // Offers

  "offers": {
    "list": {
      "tab": {
        "currently": "Currently",
        "history": "History",
        "ended": "Finished",
        "pending": "Pending",
        "all": "All",
        "active": "Live",
      },
      "heading": "Offers",
      "empty": "No offer available yet…",
      "button.create": "Create an offer",
      "is-ab-tested": "Control group",
      "is-targeted": "This offer is targeted",
      "is-main-source-transaction": "This offer rewards transactions from {source}",
      "is-no-phase": "This Offer is not displayed to your consumers because it requires an active phase. Please provide one to display it to your consumers.",
      "is-frequency": "Reward buying frequency ({frequency})",
    },
    "preview": {
      "heading": "Offers",
      "heading.essential": "Essential",
      "heading.quickedit": "Quick edit",
      "form.success": "Offre edited with success.",
      "status.ONLINE": "Online - only offer",
      "status.OFFLINE": "Offer at local store only",
      "status.BOTH": "Offer online and at local store",
      "application.placeholder.url": "Online store URL",
      "dialog.deactivate.text": "Deactivate this offer will be definitive after saving.",
      "phases.heading.evolution": "Reward Rate Phase",
      "phases.button.delete": "Delete",
      "phases.button.adjust": "Adjust",
      "phases.button.details": "Details",
      "phases.button.add": "Add Modification",
      "phases.empty": "No reward rate phase planned",
    },
    "metrics": {
      "heading": "Performance",
      "heading-hint": "Performance over the observed period",
      "heading.activations": "Number of active consumers",
      "heading.activations-hint": "Number of active consumers during the period",
      "heading.average-spent": "Average baskets",
      "heading.average-spent-hint": "Average spending of customers who participated over the observed period",
      "heading.cashback": "Amount and total number of Rewards",
      "heading.cashback-hint": "The graph shows the total number (disk) and amounts of Rewards (ordinates) generated over the observed period.",
      "heading.commissions": "Fees",
      "heading.commissions-hint": "Fees paid to Paylead over the period observed",
      "heading.overtime": "Activity",
      "heading.overtime-hint": "A set of charts to evaluate your popularity",
      "heading.performance": "Performance",
      "heading.performance-hint": "Performance over the observed period",
      "heading.total-spent": "Generated turnover",
      "heading.total-spent-hint": "Total Turnover Generated over the period",
      "from-beginning-to": "From beginning of the offer to { end }",
      "load-error": "The metrics could not be loaded. Reload the page or try again later…"
    },
    "form": {
      "recipient.network": "This offer is available in all stores of the network: ",
      "recipient.brand": "This offer is available in all stores of the brand:",
      "recipient.stores": "This offer is available in all following stores:",
    },
    "dialog": {
      "reward-move": {
        "heading": "Add Reward Phase",
        "heading.edit": "Edit Reward Phase",
      }
    },
    "shared": {
      "label": {
        "offer-deactivated": "This offer has been deactivated.",
        "offer-active": "Active offer",
        "offer-inactive": "Inactive offer",
        "offer-activate": "Activate offer",
        "offer-deactivate": "Deactivate offer",
        "end_date": "End date",
        "deactivated_at": "Deactivation date",
        "completed_at": "Completed date",
        "end-date": "Offer date expired",
        "deactivated-at": "Offer deactivated",
        "completed-at": "Budget reached",
        "custom": "Custom",
      },
      "types": {
        'ALL': 'All',
        "UNIQUE_COUPON": "Unique coupon",
        "GENERIC_COUPON": "Generic Coupon",
        "CASHBACK": "Reward",
        "AFFILIATION": "Affiliation",
        "LBS_CASHBACK": "Reward LBS"
      }
    },
  },

  // Coupons

  "coupons": {
    "list": {
      "tab": {
        "currently": "Currently",
        "ended": "Finished",
        "pending": "Pending",
        "all": "All",
        "active": "Live",
      },
      "heading": "Coupons",
      "empty": "No coupon available yet…",
      "button.create": "Create a coupon",
    },
    "generic": {
      "form": {
        "heading": "Generic coupon",
        "heading.essential": "Essential",
        "heading.terms": "Legals terms and application",
      }
    },
    "unique": {
      "form": {
        "heading": "Unique coupon",
        "heading.essential": "Essential",
        "heading.terms": "Legals terms and application",
        "hint.coupon-file": "CSV file with one code per ligne",
        "hint.coupon-amount": "Auto generated"
      }
    },
    "metrics": {
      "heading": "Performance",
      "heading-hint": "Performance over the observed period",
      "heading.activations": "Number of active consumers",
      "heading.activations-hint": "Number of active consumers during the period",
      "heading.average-spent": "Average baskets",
      "heading.average-spent-hint": "Average spending of customers who participated over the observed period",
      "heading.cashback": "Amount and total number of Rewards",
      "heading.cashback-hint": "The graph shows the total number (disk) and amounts of Rewards (ordinates) generated over the observed period.",
      "heading.commissions": "Fees",
      "heading.commissions-hint": "Fees paid to Paylead over the period observed",
      "heading.overtime": "Activity",
      "heading.overtime-hint": "A set of charts to evaluate your popularity",
      "heading.performance": "Performance",
      "heading.performance-hint": "Performance over the observed period",
      "heading.total-spent": "Generated turnover",
      "heading.total-spent-hint": "Total Turnover Generated over the period",
    },
    "form": {
      "header.multistore": "Multiple",
      "heading.application": "Channel",
      "recipient.network": "This coupon is available in all stores of the network: ",
      "recipient.brand": "This coupon is available in all stores of the brand:",
      "recipient.stores": "This coupon is available in all following stores:",
      "application.placeholder.url": "Please type the URL of the online offer…",
      "date-start-past": "Has started { date } at { time } (Paris)",
      "date-start-future": "Will start { date } at { time } (Paris)",
      "date-end-past": "Has ended { date } at { time } (Paris)",
      "date-end-future": "Will end { date } at { time } (Paris)",
      "form.success": "Coupon successfully edited.",
      "no-editable-fields": "This offer is over. It is no longer editable.",
      "no-editable-fields-reactivable": "This offer is deactivated. It is no longer editable.",
    },
    "selection": {
      "heading": "Coupons / Select",
      "heading.choose": "Select a coupon type:",
      "action1": {
        "heading": "Generic Coupons",
        "text": "Reusable simple-code offer. For example: SANTA20 to be typed in by the user when purchasing online.",
        "button": "Create offer with generic coupon",
      },
      "action2": {
        "heading": "Unique Coupons",
        "text": "Coupon-based offer (QR code, barcode, or simple) generated for the consumers. It must be shown at checkout to benefit from the discount.",
        "button": "Create offer with unique coupon",
      }
    },
    "recipients": {
      "heading": "Offers / Recipients",
      "heading.choose": "Choose recipients",
      "search-brand": "Search a brand...",
      "empty": "No recipient found…",
      "empty-cart": "No item selected yet...",
      "select-hint": "On this page",
      "store-count": "{ nb, plural, =0 {No store} =1 {# store} other {# stores} }",
    },
    "dialog": {
      "publication-date": {
        "heading": "Coupon publication",
        "choice-1": "As soon as possible (tomorrow)",
        "choice-2": "At a specific date and time"
      }
    },
    "shared": {
      "label": {
        "funded-by": "Is funded by",
        "coupon-active": "Active",
        "coupon-inactive": "Inactive",
      },
      "summary": {
        "heading": "Summary",
        "checklist": {
          "details": "Coupon details",
          "target": "Targeting",
          "terms": "Legal Terms",
          "published": "Published on",
        },
        "current-state": "Current state",
        "current-state-hint": "Définitif",
        "remaining-time": "Remaining time",
        "remaining-time-count": "{ nb, plural, =0 {# day} =1 {# day} other {# days} }",
        "remaining-day-left-count": "{ nb, plural, =0 {# day} =1 {# day} other {# days} } left",
        "remaining-budget": "Remaining budget",
        "remaining-coupons": "Remaining coupons",
        "no-more-budget": "This coupon initial budget of { value } was completely depleted.",
        "no-more-time": "This coupon ended on { date }",
        "cancelled": "This coupon has been cancelled.",
        "published": "Published",
        "waiting-publication": "Waiting for publication",
        "publication": "Publication",
        "activation": "Activation",
      },
      "types": {
        "UNIQUE_COUPON": "Unique coupon",
        "GENERIC_COUPON": "Generic coupon",
        "CASHBACK": "Reward"
      }
    }
  },

  // Consumers

  "consumers": {
    "list": {
      "heading": "Consumers",
      "empty": "No consumer yet…",
      "tab": {
        "all": "All",
        "active": "Active",
        "inactive": "Inactive",
      },
    },
    "details": {
      "heading": "Consumer",
      "heading.details": "Consumer details",
      "heading.activity": "Consumer activity",
      "tab.activities": "Activities",
      "tab.cashbacks": "Rewards",
      "tab.offers": "Offers",
      "tab.transfers": "Transfers",
      "tab.connections": "Synchronizations",
      "tab.vouchers": "Vouchers",
      "table.technical-status": "Technical status",
      "table.consumer-status": "Consumer status",
      "empty.cashbacks": "No reward yet…",
      "empty.transfers": "No transfert yet…",
      "empty.activities": "No activity yet…",
      "empty.connections": "No connection yet…",
      "total-cashback": "Total amount of rewards with status ”{status}”",
      "minimum-trigger": "{amount} minimum to trigger the cagnotte",
      "optout-hint": "Opt-out",
      "optout-confirm": "Please confirm the withdrawal of consumer <strong>{consumer}'s</strong> consent to be targeted with the <strong>{level}</strong> feature",
      "not-found": "No Consumer has been found with this ID…",
      "empty": "Enter a Consumer ID in the search bar above.",
    },
    "cashback": {
      "heading.details": "Reward details",
      "heading.history": "Reward history",
      "heading.attributions": "Attributions",
      "heading.status-history": "Status history",
      "status-history.date": "Date",
      "status-history.kind": "Status",
      "status-history.previous-status": "Previous status",
      "status-history.new-status": "New status",
      "status-history.origin": "Origin",
      "status-history.kind-TECHNICAL": "Technical",
      "status-history.kind-CONSUMER": "Consumer",
      "status-history.origin-AUTO": "Auto",
      "status-history.origin-API": "API",
      "status-history.origin-UNKNOWN": "Unknown",
    },
    "voucher": {
      "heading.details": "Voucher details",
      "heading.history": "Voucher history",
      "heading.content": "Voucher content",
      "heading.downloads": "Voucher downloads",
      "download": "Downloaded by",
      "content.updated-at": "Voucher updated on",
      "content.card-number": "Card Number (EAN or QR)",
      "content.pin-code": "Card Pin",
      "content.card-url": "Card URL",
      "content.card-pdf": "PDF"
    },
    "transfer": {
      "heading.details": "Transfer details"
    }
  },

  // Consumer events

  "consumer-events": {
    "list": {
      "heading": "Life events",
      "empty": "No event yet…",
      "button.create": "Add an event",
    },
    "form": {
      "heading": "Life events / Edit",
      "heading.info": "Information",
      "heading.details": "Event details",
      "heading.configuration": "Configuration",
      "heading.detection": "Transaction detection",
      "heading.detection-hint": "If left empty, all trasactions will be examined.",
      "heading.simulation": "Simulation",
      "heading.time-period": "Time period",
      "heading.monthly-aggregation": "Monthly aggregation",
      "heading.period-aggregation": "Period aggregation",
      "heading.conditions": "Conditions",
      "tab.one-period": "Single time period",
      "tab.one-period.hint": "When you are looking for change that lasts particular time",
      "tab.two-periods": "Two subsequent time periods",
      "tab.two-periods.hint": "When you are looking for change between two periods of time",
      "text.simulation": "Before you activate your new Life Event, you can run a simulation that will be based on the past consumer activity.",
      "form.success": "Event successfully edited.",
      "including": "Including",
      "excluding": "Excluding",
      "placeholder.label": "Type a label and press Enter key",
      "placeholder.never": "Never",
      "placeholder.no-start-day": "None",
      "button.add-condition": "Add a condition",
      "monthly-aggregation": "Monthly aggregation",
      "monthly-aggregation.hint": "Aggregation of all detected transactions values per month.",
      "observation-value": "Observation value",
      "observation-aggregation": "Observation aggregation",
      "observation-aggregation.hint": "Aggregation of all monthly observation period. Result is “Observation Value“.",
      "confirmation-value": "Confirmation value",
      "confirmation-aggregation": "Confirmation aggregation",
      "confirmation-aggregation.hint": "Aggregation of all monthly confirmation period. Result is “Confirmation Value“.",
      "confirm-tab-change": "Some of your conditions contains a observation value which is not compatible with this Single Tab Period. These conditions will be removed.",
      "periods-observation": "Observation period",
      "periods-gap": "Time gap",
      "periods-confirmation": "Confirmation period",
      "months-consecutive": "consecutive months",
      "months-no-data": "months without transactional data",
      "months-between-periods": "months between observation and confirmation",
      "condition-nb": "Condition { nb }",
      "custom-value": "Custom value",
      "start-day": "Month start day",
      "expiration-delay": "Expiration delay (in months)",
    },
    "details": {
      "heading": "{ name } Log",
      "heading.details": "Details",
      "tab.summary": "Summary",
      "tab.overtime": "Occurrences Overtime",
    },
    "shared": {
      "delete": {
        "title": "Delete this event?",
        "text": "Deleting event will permanently remove it. This cannot be undone."
      },
      "operator": {
        "GT": "Greater than",
        "LT": "Lower than",
      }
    },
  },

  // Rewards

  "rewards": {
    "list": {
      "heading.cashbacks": "Rewards",
      "heading.gifts": "Gifts",
      "empty": "No data yet…",
      "tab": {
        "all": "All",
        "paid-out": "Paid out",
        "paid-in": "Paid in",
        "validated": "Validated",
        "pending": "Pending",
      },
    },
    "details": {
      "heading.cashbacks": "Reward",
      "heading.gifts": "Gift",
      "heading.details": "Details",
      "heading.history": "History",
    },
    "dialog": {
      "import": {
        "heading": "Import gifts by CSV",
        "message": "Upload a CSV file with a CONSUMER_ID;AMOUNT;REWARD_NAME per line. Separated by a semicolon.",
        "errors": "There {errors, plural, =1 {is # error} other {are # errors} } in this CSV file.",
        "form.success": "Gift imported successfully.",
      }
    },
    "shared": {
      "type": {
        "GIFT": "Cadeau",
        "CASHBACK": "Reward",
        "CASHBACK_AFFILIATION": "Affiliated",
        "LBS_CASHBACK": "Reward LBS",
        "EVO_CASHBACK": "Voucher cashback",
      }
    }
  },

  // ventilations

  "ventilations": {
    "list": {
      "heading": "Ventilation",
      "empty": "No Ventilation yet…",
      "tab": {
        "all": "All",
        "paid-out": "Paid out",
        "paid-in": "Paid in",
        "validated": "Validated",
        "pending": "Pending",
      },
    },
    "details": {
      "heading": "Ventilation",
      "heading.details": "Ventilation details",
      "heading.history": "Ventilation history",
    },
    "shared": {
      "type": {
        "GIFT": "Cadeau",
        "CASHBACK": "Reward",
      },
      "table": {
        "fee_invoice_reference": "Invoice reference",
        "invoicing_cycle": "Cycle (YYYY-MM)",
        "amount": "Total amount to allocate",
        "payout": "Payout reference",
      }
    }
  },

  // affiliaton ventilations

  "affiliation_ventilations": {
    "list": {
      "heading": "Affiliation ventilation",
      "empty": "No affiliation ventilation yet…",
    },
    "shared": {
      "table": {
        "invoicing_cycle": "Invoicing cycle",
      }
    }
  },

  // Transactions

  "transactions": {
    "list": {
      "heading": "Transactions",
      "empty": "No transaction available yet…",
    },
    "details": {
      "heading": "Transactions",
      "heading.payment": "Payment",
      "heading.status": "Status",
      "heading.information": "Information",
      "heading.client": "Client",
      "button.cancel": "Cancel this transaction",
      "cashback-cancelled": "This transaction has been cancelled:"
    },
    "dialog": {
      "status": {
        "heading": "Reward cancellation",
        "text":
          `You are about to cancel this consumer reward.
          <b>This action is final</b>.
          Please give the reason for this cancellation.`
      }
    }
  },

  // Segments

  "segments": {
    "list": {
      "heading": "Segments",
      "empty": "No segment available yet…",
      "button.import": "Assign consumers",
      "table.consumers": "Consumers",
      "button.export": "⬇ Download the list",
      "export.async": "This segment is large: the file will be available from the imports tracking screen.",
      "export.error": "An error occurred while downloading the list.",
    },
    "dialog": {
      "import": {
        "heading": "Import Consumers by CSV",
        "message": "Upload a CSV file with a CONSUMER_ID;SEGMENT_ID per line. Separated by a semicolon.",
        "errors": "There {errors, plural, =1 {is # error} other {are # errors} } in this CSV file.",
        "form.success": "Consumers imported successfully.",
        "template.heading": "Expected template",
        "template.download": "⬇ Download the .csv template",
        "template.comment": "required header line",
        "header.warning": "The file does not start with the consumer_id;slug header line. It will still be processed (files without a header are supported).",
      }
    },
    "imports": {
      "heading": "Imports tracking",
      "empty": "No import triggered in the last 24 hours.",
      "last-refresh": "Last refreshed at {time}",
      "button.refresh": "Refresh",
      "table": {
        "id": "Import",
        "status": "Status",
        "triggered": "Triggered",
        "completed": "Completed",
        "result": "Result",
        "report": "Report",
        "ok": "ok",
        "ko": "KO",
        "download-report": "⬇ Report",
      },
      "status": {
        "WAITING": "Waiting",
        "RUNNING": "Running",
        "SUCCESS": "Done",
        "FAILURE": "Failed",
      }
    },
  },

  // Invoices

  "invoices": {
    "list": {
      "heading": "Invoices",
      "empty": "No invoice available yet…",
      "tab": {
        "all": "All",
        "gifts": "Gifts",
        "fees": "Revenue",
        "deposits": "Voucher budget",
        "vouchers": "Vouchers",
      },
      "type": {
        "GIFT": "Gift",
        "FEE": "Revenue",
        "VOUCHER_PRICES": "Voucher",
        "VOUCHER_FEES": "Voucher revenue",
        "VOUCHER_DEPOSIT": "Voucher budget"
      }
    },
    "status": {
      "UPDATED": "Updated",
      "REGENERATED": "Re-generated",
      "GENERATED": "Generated",
    }
  },

  // Users

  "users": {
    "list": {
      "heading": "My account / Users",
      "empty": "No user yet…",
      "button.create": "Invite a user",
    },
    "form": {
      "heading": "My account / Users / Edit",
      "heading.user": "User",
      "form.success": "User successfully edited.",
      "form.deactivate-user.success": "User successfully deactivated.",
      "form.deactivate-user.error": "An error occurred while deactivating the user.",
      "button.deactivate-user": "Deactivate user"
    },
    "invite": {
      "heading": "My account / Users / Invite",
      "heading.user": "User to invite",
      "hint": "An invitation will be sent with further instruction to create an account.",
      "form.success": "User has been invited by email."
    }
  },

  // Companies

  "merchants": {
    "form": {
      "heading": "My account / Merchant",
      "heading.merchant": "Merchant",
      "heading.picture": "Logo",
      "heading.visuals": "Visuals",
      "form.success": "Your merchant information has been updated.",
    },
    "selector": {
      "heading": "Choose a merchant"
    }
  },

  // Stores

  "stores": {
    "list": {
      "heading": "My account / Stores",
      "heading.store": "Store",
      "button.create": "Add a new store",
      "empty": "No store available yet…",
      "api.not-found": "This company has not been found"
    },
    "form": {
      "heading": "My account / Stores / Add a store",
      "heading.info": "Store info",
      "heading.opening-times": "Opening times",
      "heading.affiliations": "Affiliations",
      "card-payment-ticket": "Card payment ticket",
      "add-opening-times": "Add",
      "closed": "Closed",
      "coords": {
        "find": "Find those coords from the filled address above?",
        "drag": "you can drag and drop the marker to adjust position."
      },
      "warning.affiliates": "Here is the list of partner merchants who can send offers to your store. If you notice an anomaly, do not hesitate to contact PayLead support.",
      "form.success": "Store successfully edited."
    },
    "dialog": {
      "import": {
        "heading": "Import stores by CSV",
        "message": "Upload a CSV file with a Company number and a store name per line. Separated by a comma. First line as a header (will be ignored).",
        "errors": "There {errors, plural, =1 {is # error} other {are # errors} } in this CSV file.",
        "form.success": "Stores imported successfully.",
      }
    }
  },

  // Payments

  "payments": {
    "form": {
      "heading": "My account / Payment methods",
      "heading.methods": "Payment methods",
      "tabs": {
        "bank-account": "Bank account",
        "credit-card": "Credit card",
      },
      "form.success": "Your account has been updated.",
    }
  },

  // settings

  "settings": {
    "form": {
      "heading": "My account / Settings",
      "heading.settings": "Settings",
      "heading.notifications": "Notifications",
      "heading.password": "Change your password",
      "form.success": "Your settings have been updated.",
    },
  },

  // programs

  "programs": {
    "form": {
      "heading": "My account / Program",
      "heading.program": "Program",
      "heading.terms": "Legals terms and application",
      "form.success": "Your pogram has been updated.",
    },

    "performances": {
      "heading": "Dashboard",
      "heading.funnel": "Lifecycle funnel",
      "heading.rewards-merchants": "Distribution",
      "heading.accounts-created": "Accounts created",
      "heading.accounts-created-hint": "New consumers (based on the account creation date)",
      "heading.accounts-connected": "Bank accounts connected",
      "heading.accounts-connected-hint": "Consumers who connected at least one bank account (based on the first bank account linking date)",
      "heading.transactions-shared": "Sharing transactions",
      "heading.transactions-shared-hint": "Consumers who have made at least one transaction eligible for rewards (based on the transaction execution date)",
      "heading.statuses": "Current status of user accounts",
      "heading.statuses-hint": "Distribution of scraped account connexion statuses (based on the bank account linking date)",
      "heading.breakdown": "Data drilldown",
      "heading.activated-consumers-unique": "Activated unique coupons",
      "heading.activated-consumers-unique-hint": "Consumers who consumed at least one unique coupon (based on the coupons reclamation date)",
      "heading.total-unique": "Number of unique coupons",
      "heading.total-unique-hint": "Number of unique coupons consumed (based on the coupons reclamation date)",
      "heading.activated-consumers-generic": "Activated generic coupons",
      "heading.activated-consumers-generic-hint": "Consumers who displayed at least one generic coupon (based on the coupons display date)",
      "heading.total-generic": "Number of generic coupons",
      "heading.total-generic-hint": "Number of generic coupons displayed (based on the coupons display date)",

      "tab": {
        "consumers": "Consumers",
        "funnel": "Funnel",
        "rewards": "ALO Rewards",
        "lbs": "LBS Rewards",
        "gifts": "Gifts",
        "coupons": "Coupons",
        "vouchers": "Vouchers"
      },

      "funnel": {
        "accounts-created": "Accounts created",
        "accounts-created-hint": "New consumers (based on the account creation date)",
        "accounts-connected": "Bank accounts connected",
        "accounts-connected-hint": "Consumers who connected at least one bank account (based on the account creation date)",
        "transactions-shared": "Sharing transactions",
        "transactions-shared-hint": "Consumers who have made at least one transaction eligible for rewards (based on the account creation date)",
        "transactions-shared-long": "Sharing transactions last 30 days",
        "transactions-shared-long-hint": "Consumers who have made at least one transaction eligible for rewards in the last 30 days (based on the account creation date)",
      },

      "rewards": {
        "total-rewards": "Total rewards",
        "total-rewards-hint": "Number of generated rewards (based on the transaction execution date)",
        "total-amount-rewards": "Total amount of rewards",
        "total-amount-rewards-hint": "Amount of generated rewards (based on the transaction execution date)",
        "sale-generated": "Sales generated",
        "sale-generated-hint": "Amount of transactions rewarded (based on the transaction execution date)",
        "total-fees": "Total fees",
        "total-fees-hint": "Total amount of fees (based on the transaction execution date)",
        "total-vouchers": "Total vouchers",
        "total-voucher-value": "Total voucher value",
        "total-voucher-sell": "Total voucher sell",
        "total-voucher-discount": "Total voucher discount",
        "total-voucher-commission": "Total voucher commission",
        "rewards-per-merchant": "Number of rewards per merchant",
        "reward-amount-per-brand": "Reward amount per brand",
        "commission-per-brand": "Commission per brand",
        "activated-consumers": "Activated",
        "activated-consumers-hint": "Consumers with at least one reward generated (based on the transaction execution date)",
        "participation-rate": "Participation rate",
        "participation-rate-hint": "Average number of rewards per activated consumers (based on the transaction execution date)",
        "average-earnings": "Average earnings",
        "average-earnings-hint": "Average amount of rewards generated per consumer (based on the transaction execution date)",
        "average-basket": "Average basket",
        "average-basket-hint": "Average amount of transactions rewarded (based on the transaction execution date)",
        "brand-distribution": "Distribution of rewards per merchant ",
        "brand-distribution-hint": "Number and total amount of rewards rewards per merchant (based on the transaction execution date)",
        "brand-total": "Total rewards per merchant",
        "brand-total-amount": "Total amount of rewards per merchant",
        "brand-earnings": "Average earnings per merchant",
        "brand-earnings-hint": "Average amount of rewards generated per merchant (based on the transaction execution date)",
        "merchants": "Merchants",
        "merchants-hint": "Distribution of rewards per merchant",
      },

      "lbs": {
        "activated-consumers": "Activated",
        "activated-consumers-hint": "Consumers with at least one LBS reward generated (based on the transaction execution date)",
        "total-rewards": "Total LBS rewards",
        "total-rewards-hint": "Number of generated LBS rewards (based on the transaction execution date)",
        "total-amount-rewards": "Total amount of LBS rewards",
        "total-amount-rewards-hint": "Total amount of generated LBS rewards (based on the transaction execution date)",
        "total-fees": "Total LBS fees",
        "total-fees-hint": "Total amount of LBS fees (based on the transaction execution date)",
        "merchants": "LBS Merchants",
        "merchants-hint": "Distribution of LBS rewards per merchant",
        "brand-earnings": "Average earnings per LBS merchant",
        "brand-earnings-hint": "Average amount of LBS rewards generated per merchant (based on the transaction execution date)",
      },

      "gifts": {
        "activated-consumers": "Activated",
        "activated-consumers-hint": "Consumers who had at least one gift generated during the selected period (based on the gift creation date)",
        "total-gifts": "Total gifts",
        "total-gifts-hint": "Number of gifts generated during the selected period (based on the gift creation date)",
        "total-amount": "Total amount of gifts",
        "total-amount-hint": "Total amount of gifts generated during the selected period (based on the gift creation date)",
      },

      "coupons": {
        "activated-consumers-unique": "Activated unique coupons",
        "activated-consumers-unique-hint": "Consumers with at least one unique coupon generated (based on coupon reclamation date)",
        "total-unique": "Number of unique coupons",
        "total-unique-hint": "Number of unique coupons generated (based on coupon reclamation date)",
        "activated-consumers-generic": "Activated generic coupons",
        "activated-consumers-generic-hint": "Consumers who displayed at least one generic coupon (based on coupon display date)",
        "total-generic": "Number of generic coupons",
        "total-generic-hint": "Number of generic coupons displayed (based on coupon display date)",
      },

      "statuses": {
        "UNKNOWN": "The status is unknown, most of the time because the consumer hasn’t synchronized his/her account yet",
        "DISABLED": "Synchronization has been disabled for this connection",
        "ERROR": "Synchronization error (bad credentials and/or consumer has an action to make on his/her bank website side)",
        "CHALLENGE_REQUIRED": "Consumer has to input a special code sent by his/her bank to aknowledge the synchronization",
        "SCRAPPING": "Consumer’s bank account is being synchronized",
        "SUCCESS": "Consumer’s bank account synchronization was a success",
        "SCA_REQUIRED": "A complete SCA process must be done by updating the connection",
        "WEBAUTH_REQUIRED": "A complete authentication process is required by update the connection via redirect",
        "WRONG_PASS": "Consumer has to input his credentials because they are invalid or obsolete",
        "ACTION_NEEDED": "Consumer has to perform a special action in his bank website, more details are available in ”error_message”",
      },

      "shared": {
        "actual": "Actual",
        "cumulative": "Cumulative",
        "earnings": "Earnings",
        "updated-at": "Data updated on",
        "view-all": "See all",
      }
    },
  },

  // Brands

  "brands": {
    "list": {
      "heading": "Brands",
      // "heading.store": "Store",
      "button.create": "Add a brand",
      "empty": "No store available yet…",
      "api.not-found": "This company has not been found"
    },
    "form": {
      "heading": "Brand",
      "heading.brand": "Brand",
      "heading.essential": "General Information",
      "heading.picture": "Logo",
      "heading.terms": "Legals terms and application",
      "form.success": "The brand has been edited.",
    },
    "recipients": {
      "heading": "Brands / Stores",
      "heading.choose": "Choose stores",
      "search-store": "Search a store...",
      "empty": "No store found…",
      "empty-cart": "No item selected yet...",
      "select-hint": "On this page",
      "store-count": "{ nb, plural, =0 {No store} =1 {# store} other {# stores} }",
    },
  },

  // Technicals

  "technicals": {
    "integration": {
      "heading": "Integration",
      "form.success": "Parameters successfully updated.",
      "awin": {
        "heading": "Awin",
        "created": "Syncing data with Awin.",
        "failed": "An error has occured. Please check your Awin API key.",
        "noempty": "The Awin API key should not be empty",
      }
    },
    "docs": {
      "heading": "Developers / API Documentation",
      "heading.doc": "API Documentation:",
      "group": '{role} Documentations',
      "type": {
        "connector": "Connector",
        "injector": "Injector",
        "program_manager": "Program Manager",
        "m2m": "Program M2M"
      }
    },
    "logs": {
      "heading": "Developers / Logs",
      "empty": "No data available yet…",
      "button.edit": "Manage Webhooks"
    },


    "webhooks": {
      "heading": "Developers / Webhooks",
      "heading.header": "Header authentication",
      "heading.hmac": "HMAC authentication",
      "heading.basic": "Basic authentication",
      "heading.hooks": "Hooks",
      "heading.first": "What are webhooks?",
      "heading.second": "To configure a webhook:",
      "text.first": "Webhooks allow you to receive data asynchronously. These data will be received in JSON format on the URLs you provided in this interface.",
      "text.second-1": "Choose a type of Webhook in the left column. For more details on the different types of Webhooks, visit our documentation.",
      "text.second-2": "Provide the URL that will receive and process the Webhook in your application.",
      "message.success.heading": "You’re all set up!",
      "message.success.text": "Select a webhook using the left column to get started.",
      "secret-hint": "32 characters minimum, alphanumeric only.",
      "form.success": "Your settings have been updated.",
      "send.success": "A fake request has been sent to this callback URL.",
      "remove.success": "This Webhook will be definitively removed after 'Save'.",
      "test.success": "Sent",
      "button": {
        "settings": "Settings"
      },
      "group": {
        "cashback": "Cashbacks",
        "payment": "Payments",
        "consumer": "Consumers",
        "affiliation": "Affiliations",
        "offer": "Offers",
      },
      "event": {
        "AFFILIATION_CANCELLED": "A webhook is sent to the URL when a pending validation affiliation reward is cancelled instead of validated.",
        "AFFILIATION_CREATED": "A webhook is sent to the URL when a consumer just received a new affiliation reward.",
        "AFFILIATION_PAID_IN": "A webhook is sent to the URL when the affiliation reward is validated by the merchant.",
        "AFFILIATION_PAID_OUT": "A webhook is sent to the URL when the merchant paid the affiliation reward. ",
        "AFFILIATION_POOLED": "A Webhook is sent to the URL when you will be able to tell consumers that an affiliation reward has been deposited in their pool.",
        "AFFILIATION_VALIDATED": "A webhook is sent to the URL when the pool is triggered and the affiliation reward sent to the payment account.",
        "CONSUMER_REWARD_CANCELLED": "A webhook is sent to the URL when you will be able to tell them a reward that was pending validation has been cancelled.",
        "CONSUMER_REWARD_PAID": "A webhook is sent to the URL when you will be able to tell them a reward has been paid to his account.",
        "CONSUMER_REWARD_POOLED": "A Webhook is sent to the URL when you will be able to tell a consumer that a reward has been deposited in his pool.",
        "CONSUMER_REWARD_VALIDATION": "A webhook is sent to the URL when you will be able to tell them a reward has been created and is pending validation.",
        "NEW_OFFER_AVAILABLE": "A webhook is sent to the URL when an offer is created.",
        "OFFER_CASHBACK_RATE_INCREASE": "A webhook is sent to the URL when the cashback rate of an offer is raised.",
        "OFFER_ENDING_SOON_BUDGET": "A webhook is sent to the URL when an offer is about to expire (when the budget reaches 80%).",
        "OFFER_ENDING_SOON_DATE": "A webhook is sent to the URL when an offer is about to expire (48 hours prior).",
        "OFFER_RATE_INCREASE": "A webhook is sent to the URL when the cashback rate of an offer is raised.",
        "PAYOUT_ERROR": "A webhook is sent to the URL when a transfer error occurs preventing the reward from being paid on the payment account.",
        "PAYOUT_SUCCESS": "A webhook is sent to the URL when refunds transfer is accepted by our payment service provider.",
        "REWARD_CANCELLED": "A webhook is sent to the URL when a pending validation reward is cancelled instead of validated.",
        "REWARD_CREATED": "A webhook is sent to the URL when when a consumer just received a new reward.",
        "REWARD_PAID_IN": "A webhook is sent to the URL when the reward amount left the merchant wallet to move to the PM wallet.",
        "REWARD_PAID_OUT": "A webhook is sent to the URL when the consumer pool has been triggered and the reward has been transferred to the payment account.",
        "REWARD_VALIDATED": "A webhook is sent to the URL when the reward is validated by the merchant (automatically after validation delay).",
        "SCRAPPING_ERROR": "A webhook is sent to the URL when a scrapping error is encountered by the consumer.",
        "VENTILATION_FILE_AVAILABLE": "A webhook is sent to the URL when a ventilation file is available.",
      }
    },

    "tokens": {
      "heading": "Developers / Api keys",
      "empty": "No API key yet…",
      "role": {
        "PROGRAM_M2M": "Program M2M",
        "CONNECTOR": "Connector",
        "INJECTOR": "Injector"
      },
      "dialog": {
        "success": {
          "title": "API Key Generated Successfully",
          "warning-title": "Important:",
          "warning-text-token": "This is the only time you will be able to see this token.",
          "warning-text-copy": "Please copy it now and store it in a secure location.",
          "api-key": "API Key",
          "client-secret": "Client Secret",
          "jwt": "JWT",
          "jwt-error": "Failed to issue a JWT. Check that the client ID and secret are correct."
        }
      },
      "button": {
        "copy": "Copy Token",
        "generate": "Generate new API key",
        "doc": "API Documentation",
        "get-jwt": "Get JWT",
        "copy-jwt": "Copy JWT",
      },
      "form": {
        "ttl-hint": "Leave blank to use the server default (3600 s).",
      }
    },
    "shared": {
      "label": {
        "REWARD_CREATED": "Reward created",
        "REWARD_VALIDATED": "Reward validated",
        "REWARD_PAID_IN": "Reward paid in ",
        "REWARD_PAID_OUT": "Reward paid out",
        "CONSUMER_REWARD_POOLED": "Consumer Reward pooled",
        "CONSUMER_REWARD_PAID": "Consumer Reward paid",
        "CONSUMER_REWARD_CANCELLED": "Consumer Reward cancelled",
        "CONSUMER_REWARD_VALIDATION": "Consumer Reward validation",
        "SCRAPPING_ERROR": "Scrapping error",
        "PAYOUT_SUCCESS": "Payout success",
        "PAYOUT_ERROR": "Payout error",
        "AFFILIATION_CREATED": "Affiliation created",
        "AFFILIATION_VALIDATED": "Affiliation validated",
        "AFFILIATION_PAID_IN": "Affiliation paid in",
        "AFFILIATION_PAID_OUT": "Affiliation paid out",
        "AFFILIATION_POOLED": "Affiliation pooled",
        "AFFILIATION_CANCELLED": "Affiliation cancelled",
        "VENTILATION_FILE_AVAILABLE": "Ventilation File Available",
        "NEW_OFFER_AVAILABLE": "New offer available",
        "OFFER_ENDING_SOON_DATE": "Offer soon ending date",
        "OFFER_ENDING_SOON_BUDGET": "Offer soon ending budget",
        "OFFER_CASHBACK_RATE_INCREASE": "Offer cashback rate increase",
        "filter_type": "Filter by type...",
      },
      "hint": {
        "REWARD_CREATED": "Will be called when a consumer just received a new reward",
        "REWARD_VALIDATED": "Will be called when the reward is validated by the merchant (automatically after validation delay)",
        "REWARD_PAID_IN": "Will be called when the merchant has actually paid the reward",
        "REWARD_PAID_OUT": "Will be called when the consumer pool has been triggered and reward has been transfered to the payment account",
        "CONSUMER_REWARD_POOLED": "A Webhook is sent to the URL when you will be able to tell a consumer that a reward has been deposited in their pool.",
        "CONSUMER_REWARD_PAID": "A webhook is sent to the URL when you will be able to tell them a reward has been paid to his account.",
        "CONSUMER_REWARD_CANCELLED": "A webhook is sent to the URL when you will be able to tell them a reward that was pending validation has been cancelled.",
        "CONSUMER_REWARD_VALIDATION": "A webhook is sent to the URL when you will be able to tell them a reward has been created and is pending validation.",
        "SCRAPPING_ERROR": "Will be called when a scrapping error occurs to a consumer",
        "PAYOUT_ERROR": "Will be called when a transfer error occurs and the reward can't be paid on the payment account",
        "PAYOUT_SUCCESS": "Will be called when a reward payment transfer is accepted by our payment service provider",
        "AFFILIATION_CREATED": "Will be called when a consumer just received a new affiliation reward",
        "AFFILIATION_VALIDATED": "Will be called when the affiliation reward is validated by the merchant (automatically after validation delay)",
        "AFFILIATION_PAID_IN": "Will be called when the merchant has actually paid the affiliation reward",
        "AFFILIATION_PAID_OUT": "Will be called when the consumer pool has been triggered and affiliation reward has been transfered to the payment account",
        "AFFILIATION_POOLED": "A Webhook is sent to the URL when you will be able to tell a consumer that an affiliation reward has been deposited in their pool.",
        "AFFILIATION_CANCELLED": "A webhook is sent to the URL when a pending validation affiliation reward is cancelled instead of validated.",
        "VENTILATION_FILE_AVAILABLE": "A webhook is sent to the URL when a ventilation file is available.",
        "NEW_OFFER_AVAILABLE": "A webhook is sent to the URL when an offer is created.",
        "OFFER_ENDING_SOON_DATE": "A webhook is sent to the URL when an offer is about to expire.",
        "OFFER_ENDING_SOON_BUDGET": "A webhook is sent to the URL when an offer is about to expire.",
        "OFFER_CASHBACK_RATE_INCREASE": "A webhook is sent to the URL when the cashback rate of an offer is raised.",
      },
      "status": {
        "1xx": "1xx - Informational response",
        "2xx": "2xx - Success",
        "3xx": "3xx - Redirection",
        "4xx": "4xx - Client error",
        "5xx": "5xx - Server error",
        "others": "Others",
        "filter": "Filter by status"
      },
    }
  },

  // 404 page

  "errors": {
    "404": {
      "heading": "Page not found…",
      "message": "Please click the button below to go back to the previous page.",
      "button.back": "Back to previous page",
    },
  },

  // Shared

  "shared": {
    "apply-all": "Apply to all",
    "empty": "No data yet…",
    "clipboarded": "Copied to clipboard",
    "timezone": "The current timezone is Central European time.",
    "type-search": "Type to search…",
    "not-found": "No items found…",
    "loading": "Loading…",
    "warning": "Warning:",
    "need-help-call": "Need help? Give us a call!",
    "yes": "Yes",
    "no": "No",
    "tags": {
      "start_date": "Start date",
      "end_date": "End date",
      "rate": "Rate",
    },
    "api": {
      "error": {
        "down": "Sorry, we‘re having a problem connecting to our servers. Please retry later."
      }
    },
    "heading": {
      "brand-details": "Brand details",
      "program-details": "Program details",
      "commission-group": "Commission groups"
    },
    "form": {
      "invalid": "The form is invalid. Please correct marked fields.",
      "error": {
        "required": "Required",
        "email": "This email address is invalid",
        "password-match": "The password and confirmation do not match",
        "password-strength": "Must contains at least 1 digit",
        "password-not-found": "Incorrect password",
        "minlength": "Must be at least { requiredLength } chars long",
        "pattern": "Invalid value",
        "max": "Must be lower than { requiredValue }",
        "min": "Must be higher than  { requiredValue }",
        "type": "File type is not valid",
        "min_size": "File too light. Min { readableValue }",
        "max_size": "File too heavy. Max { readableValue }",
        "min_width_height": "Too small. Min { requiredValue } pixels",
        "max_width_height": "Too big. Max { requiredValue } pixels",
        "min_width": "Too small (width). Min { requiredValue } pixels",
        "max_width": "Too large (width). Max { requiredValue } pixels",
        "min_height": "Too small (height). Min { requiredValue } pixels",
        "max_height": "Too large (height). Max { requiredValue } pixels",
        "min_aspect_ratio": "Aspect ratio too low. Min { requiredValue } %",
        "max_aspect_ratio": "Aspect ratio too high. Max { requiredValue } %",
        "iban": "Invalid IBAN",
        "bic": "Invalid BIC",
        "already-exists": "Already exists in our database"
      },
      "success": {
        "upload": "File successfully uploaded"
      }
    },
    "dialog": {
      "company_number": {
        "heading": "Search a store by Company number"
      },
      "mandate": {
        "heading": "Mandate request",
        "text": `
          In the context of the new legal provisions relating to the application of European banking standards, reward and commission payments will be executed through a SEPA direct debit, carried out under a single mandate reference.
          Our partner Mangopay is responsible for the preservation of the electronic mandate.
          By this mandate, you authorize Mangopay to issue a monthly order, when necessary for the collection of rewards and commissions on your bank account.
          For any question, you can join our support [ support@paylead.fr ]
        `
      },
      "alert": {
        "heading": "Alert",
        "api": {
          "heading": "Ooops! Server problem!",
          "heading.400": "Invalid data",
          "text": "We have a server error that says:",
          "retry": "Please retry in a few minutes.",
        }
      },
      "confirm": {
        "heading": "Confirmation",
        "text": "Are you sure?",
        "text.navigation": "You're leaving this page without saving your modifications.",
        "text.delete.item": "Please confirm to delete this item.",
        "text.delete.picture": "Please confirm to delete this picture.",
        "text.delete.store": "Please confirm to delete this point of sale.",
        "text.deactivate-user": "Are you sure you want to deactivate this user? This action is permanent.",
      },
      "token-generate": {
        "heading": "API key generation",
      },
      "password": {
        "heading": "Security Unlock",
        "unlock": "Unlock",
        "error": "Wrong password.",
      },
      "illustration": { "heading": "Choose an illustration", "notfound": "No illustration available" }
    },
    "sidebar": {
      "documentation": "Doc",
      "back": "Back",
      "support": "Support",
      "ticket": "Ticket",
      "reporting": "Reporting",
      "docs": "Documentations API",
      "segments": "Segments",
      "campaigns": "Campaigns",
      "gifts": "Gifts",
      "ventilation": "Ventilation",
      "ventilation_affiliation": "Affiliation ventilation",
      "coupons": "Coupons",
      "event-log": "Event log",
      "kyb": "KYB Compliance",
      "help": "Need help?",
      "consumers": "Consumers",
      "consumer-events": "Life events",
      "performances": "Performances",
      "program": "Program",
      "affiliations": "Affiliations",
      "management": "Store management",
      "brands": "Brands",
      "networks": "Networks",
      "dashboard": "Dashboard",
      "offers": "Offers",
      "users": "Users",
      "transactions": "Transactions",
      "invoices": "Invoices",
      "account": "My account",
      "merchant": "Merchant",
      "stores": "Stores",
      "logs": "Event logs",
      "hooks": "Hooks",
      "tokens": "API Keys",
      "integration": "Integration",
      "rewards": "Rewards",
      "vouchers": "Vouchers",
      "payment": "Payment methods",
      "settings": "Settings",
      "status": "Account status",
      "logout": "Sign Out",
      "logged-as": "Logged as",
      "technical": "Developers",
      "intro-1-title": "PayLead, the customer centric marketing revolution",
      "intro-1-text": "Discover an innovative solution to address your consumers and prospects. A few clicks are enough to create an efficient promotion campaign in line with your marketing strategy : online or offline, localized or national, to reach a targeted or a wide audience",
      "intro-2-title": "Advertise for free ",
      "intro-2-text": "Get an optimal exposure with your consumers and prospects: you only pay when a sale is made, as a reward refunded to the consumer.",
      "intro-3-title": "Drive the performance",
      "intro-3-text": "Benefit from precise performance indicators that will allow you to evaluate and adjust your campaigns, while visualizing your return on investment.",
      "intro-4-title": "Improve your customer knowledge",
      "intro-4-text": "Use our expertise in Big Data and Artificial Intelligence to better understand your customers' consumption habits and optimize your marketing strategies.",
    },
    "pagination": {
      "meta": "{ from } / { to } on {total, plural, =1 {# item} other {# items} }",
      "empty": "No item…",
    },
    "filter": {
      "keyword": "Filter by keyword…",
      "date-from": "Date From…",
      "date-to": "Date to…",
      "date": "Date…",
      "segments": "Filter by segments",
      "exact-consumer-id": "Search with the consumer ID"
    },
    "counts": {
      "frequency": "1 out of {frequency} transactions",
      "offers": "{ nb, plural, =0 {No offer} =1 {# offer} other {# offers} }",
    },
    "role": {
      "ADMIN": "Administration",
      "TECHNICAL": "Technical",
      "FINANCE": "Financial",
      "OFFER": "Offers",
      "GIFT": "Gifts",
      "SUPPORT": "Consumer support",
      "REPORTING": "Reporting"
    },
    "status": {
      "WEBAUTH_REQUIRED": "Webauth required",
      "WRONG_PASS": "Wrong pass",
      "ACTION_NEEDED": "Action needed",
      "ALL": "All",
      "CREATED": "Created",
      "ACTIVE": "Active",
      "CANCELLED": "Cancelled",
      "CHALLENGE_REQUIRED": 'Challenge required',
      "COMPLETED": "Completed",
      "DEACTIVATED": "Deactivated",
      "DISABLED": 'Disabled',
      "DRAFT": "Draft",
      "ENDED": "Ended",
      "ERROR": "Error",
      "FAILED": "Failed",
      "HIGH": "High",
      "HIGHEST": "Highest",
      "INACTIVE": "Inactive",
      "MISSING": "Missing",
      "NORMAL": "Normal",
      "NOT_ATTRIBUTED": "Not attribued",
      "NOT_STARTED": "Not started",
      "PAID_IN": "Pool",
      "PAID_OUT": "Paid",
      "PAID": "Paid",
      "PAYMENT_FAILED": "Payment failed",
      "PENDING_MODERATION": "Pending moderation",
      "PENDING_VALIDATION": "Pending validation",
      "PENDING_ATTRIBUTION": "Pending attribution",
      "PENDING": "Pending",
      "POOLED": "Pooled",
      "PUBLISHED": "Published",
      "REJECTED": "Rejected",
      "SCA_REQUIRED": "Authentication required",
      "SCRAPPING": 'Scrapping',
      "SUCCESS": "Ok",
      "SUCCEEDED": "Ok",
      "SYNCED": "Synced",
      "TRANSFERED": "Transfered",
      "VALIDATED": "Validated",
      "VALIDATION": "In validation",
      "WAITING_FOR_PUBLICATION": "Waiting",
      "RESERVED": "Reserved",
      "CONFIRMED": "Confirmed",
      "READY": "Ready",
      "REFUNDING": "Refunding",
      "REFUNDED": "Refunded",
      "REFUND_REJECTED": "Refund rejected",
      "TODO": "To do",
    },
    "table": {
      "parameters": "Parameters",
      "channel": "Channel",
      "roles": "Roles",
      "discount": "Discount",
      "rentability": "Rentability",
      "price": "Price",
      "value": "Value",
      "activations": "Activations",
      "campaign": "Campaign",
      "chanel": "Chanel",
      "group": "Group",
      "remaining": "Remaining",
      "offer-activated": "Active offers",
      "universes": "Universes",
      "segments": "Segments",
      "gifts": "Gifts",
      "token": "API Key",
      "label": "Label",
      "description": "Description",
      "scopes": "Scopes",
      "ttl": "TTL (s)",
      "client-id": "Client ID",
      "payout": "Pay out",
      "reward": "Reward",
      "last-month": "Last month",
      "bankwire": "Bank wire",
      "origin": "Origin",
      "payout-id": "Payout ID",
      "tos-acceptance": "TOS acceptance",
      "consumer": "Consumer",
      "url": "URL",
      "url-callback": "Callback URL",
      "accounts": "Accounts",
      "transfer": "Transfer",
      "transaction": "Transaction",
      "id": "ID",
      "last-activity-date": "Last activity",
      "scrapping": "Scrapping",
      "descriptor": "Label",
      "validation-delay": "Validation delay",
      "highlight": "Highlight",
      "stores": "Stores",
      "offers-issued": "Offers issued",
      "offers-live": "Offers live",
      "brand": "Brand",
      "invididual": "Individual",
      "network": "Network",
      "first-name": "First name",
      "last-name": "Last name",
      "completion": "Completion",
      "created-at": "Created",
      "updated-at": "Updated",
      "trigger-at": "Triggered",
      "activity": "Last activity",
      "email": "Email",
      "type": "Type",
      "reference": "Reference",
      "redemption": "Redemption",
      "actions": "Actions",
      "amount": "Amount",
      "card": "Card",
      "cashback": "Reward",
      "city": "City",
      "commission": "Commission",
      "date": "Date",
      "date-accepted": "Accepted",
      "date-publication": "Publication",
      "date-most-recent-transaction": "Most recent transaction",
      "date-first": "1st connection",
      "date-sync": "Last connection",
      "date-sync-success": "Last successful connection",
      "dates": "Period",
      "dates-activation": "Activation period",
      "real-end-date": "Real end date",
      "fees": "Fees",
      "values": "Values",
      "invoice": "Invoice",
      "merchant": "Merchant",
      "month": "Month",
      "name": "Name",
      "name-original": "Orignal name",
      "name-edited": "Edited name",
      "next-try": "Next Try",
      "maximum-retries": "Max retries reached",
      "number": "Number",
      "offer": "Offer",
      "participants": "Participants",
      "rate": "Rate",
      "serial": "Number",
      "company_number": "Company number",
      "status": "Status",
      "zipcode": "Zip code",
    },
    "label": {
      "offer-lifespan": "Offer’s lifespan",
      "reward-info": "Reward information",
      "audience-reach": "Audience reach",
      "reward-frequency": "Reward frequency",
      "commission-max": "Commission max.",
      "example": "Example",
      "callback-url": "Callback URL",
      "on": "on",
      "others": "Others",
      "total": "Total",
      "api-key": "API key",
      "client-id": "Client ID",
      "label": "Label",
      "scopes": "Scopes",
      "secret": "Secret",
      "secret-jwt": "JWT secret",
      "values": "Values",
      "roles": "Roles",
      "url-destination": "Destination URL",
      "reward-current": "Current reward rate",
      "reward-rate-max": "Max reward ratem",
      "reward-amount-fixed": "Max fixed amount reward",
      "audience": "Audience",
      "audience-estimated": "Estimated audience",
      "audience-estimated-hint": "Eligibility criteria will be reapplied at offer creation, which may change the final size.",
      "audience-will-be-computed": "Will be computed when offer starts",
      "audience-computing-in-progress": "Computing in progress",
      "documents": "Documents",
      "details": "Details",
      "visuals": "Visuals",
      "performance": "Performance",
      "campaigns": "campaigns",
      "sync": "Synchronisation",
      "account": "Compte",
      "strategies": "Stratégies",
      "token": "Token",
      "share": "Share",
      "price-range": "Price range",
      "rewarded-price-range": "Rewarded price range",
      "activation": "Activation",
      "channel": "Channel",
      "channel-url": "Channel URL",
      "validation-delay": "Validation delay",
      "targeting": "Targeting",
      "ab-testing": "Control group",
      "capping": "Capping",
      "segments": "Segments",
      "offline": "In store",
      "online": "Online",
      "online-offline": "Online & In store",
      "brand": "Brand",
      "brand-name": "Brand name",
      "terms": "Legal Terms",
      "policy.statistics": "Statistics",
      "policy.basic": "Basic",
      "policy.transaction_triggers": "Transaction triggers",
      "policy.targeting": "Targeting",
      "policy.smart_ranking": "Smart ranking",
      "policy.web_analytics": "Web Analytics",
      "offer-details-viewed": "offer detail view",
      "score-onboarding": "Onboarding score",
      "score-last-touch": "Last touch point score",
      "score-rewarding": "Rewarding score",
      "score-global": "Global score",
      "key": "Key",
      "occurrences": "Occurrences",
      "consumers": "Consumers",
      "last-activity-date": "Last activity",
      "labels": "Labels",
      "categories": "Categories",
      "url": "URL",
      "url-callback": "Callback URL",
      "vat": "VAT",
      "account-owner": "Account owner",
      "account-payout": "Payout account",
      "account-target": "Target account",
      "activations": "Number of customers",
      "activations-hint": "Number of customers participating over the period observed",
      "address": "Address",
      "address-billing": "Billing address",
      "affiliate": "Affiliate",
      "amount": "Amount",
      "application": "Channel",
      "at": "at",
      "average": "Average",
      "average-basket": "Average basket",
      "average-basket-hint": "Average basket",
      "bank-receipt": "Bank receipt",
      "bic": "BIC",
      "by": "By",
      "for": "For",
      "card": "Card",
      "card-holder": "Card holder",
      "card-number": "Card number",
      "cashback": "Reward",
      "cashback-client": "Client reward",
      "city": "City",
      "commission": "Commission",
      "commissions": "Commissions",
      "country": "Country",
      "no-file-selected": "No file selected…",
      "no-file-uploaded": "No file uploaded…",
      "file-uploaded": "{ filename } uploaded",
      "coupon-amount": "Coupon amount",
      "coupon-file": "Coupon file",
      "coupon-total": "Max coupons",
      "coupon-type": "Coupon type",
      "coupon-discount": "Discount",
      "coupon-max-per-user": "Maximum number per consommer",
      "created-at": "Created",
      "executed-at": "Executed",
      "updated-at": "Updated",
      "triggered-at": "Triggered",
      "date": "Date",
      "date-from": "Date From",
      "date-to": "Date to",
      "date-publication": "Publication date",
      "dates": "Dates",
      "description": "Description",
      "email": "Email",
      "emails": "emails",
      "expiry-date": "Expiry date",
      "fees": "Fees",
      "filename": "File name",
      "first-name": "First name",
      "highlight-level": "Highlight level",
      "hours": "hours",
      "iban": "IBAN",
      "keyword": "Keyword",
      "keywords": "Keywords",
      "language": "Language",
      "last-activity": "Last activity",
      "last-name": "Last name",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "max-limit-transaction-amount": "Maximal transaction eligible amount",
      "max-spent": "Maximum spent",
      "merchant-name": "Merchant name",
      "min-spent": "Minimum spent",
      "mobile": "Mobile",
      "multiple": "Multiple",
      "name": "Name",
      "notifications": "notifications",
      "number": "Number",
      "offer": "Offer",
      "offer-name": "Offer name",
      "coupon-name": "Coupon name",
      "offer-reference": "Offer reference",
      "coupon-reference": "Coupon reference",
      "offers": "Offres",
      "password": "Password",
      "password-old": "Old password",
      "password-retype": "Retype your password",
      "password-security": "Security level",
      "phone": "Phone",
      "price": "Price range",
      "price-max": "Maximum price",
      "price-max-no": "No maximum price",
      "price-min": "Minimum price",
      "price-min-no": "No minimum price",
      "privacy-acceptance": "Privacy policy acceptance",
      "program-name": "Program name",
      "publication-date": "Publication date",
      "rate": "Reward rate",
      "discount": "Discount rate",
      "redemption": "Number of transactions",
      "redemption-hint": "Number of transactions rewarded by this offer over the observed period",
      "redemption-rate": "Participation Rate",
      "redemption-rate-hint": "Average amount of rewards generated per user",
      "reference": "Reference",
      "remaining-time": "Remaining time",
      "remaining-time-count": "{ nb, plural, =0 {day} =1 {# day} other {# days} }",
      "reward-average": "Average reward",
      "reward-average-hint": "Average gain per rewarded transaction",
      "acquisition-cost": "Cost Per Acquisition",
      "acquisition-cost-hint": "The average cost per acquisiton of each consumer participating to an offer",
      "forwarded-kyc": "Forwarded KYC",
      "account-sync": "Account sync",
      "scrapping": "Scrapping",
      "screen": "Screen",
      "security-code": "Securiry code (CVC)",
      "security-code-help": "3 or 4 digits code",
      "select-file": "Select a file",
      "select-picture": "Select a picture",
      "select-universe": "Select an universe",
      "sendings": "sendings",
      "company_number": "Company number",
      "status": "Status",
      "status-start": "Start with status",
      "step": "Step",
      "store-name": "Store name",
      "tos-acceptance": "TOS acceptance",
      "total-activations": "Number of participating customers",
      "total-activations-hint": "Number of customers participating in the offer over the period observed. A customer is considered a participant if he or she received at least one Reward with this offer",
      "total-cashback": "Total amount of Rewards",
      "total-cashback-hint": "Total amount of Rewards generated in the period",
      "total-commissions": "Total fees",
      "total-commissions-hint": "Generated fees over the observed period",
      "total-details-views": "Total details views",
      "total-details-views-hint": "Total clicks on this offer",
      "total-listing-views": "Total listing views",
      "total-listing-views-hint": "Total number of display of this offer in a listing",
      "total-redemption": "Number of Rewards",
      "total-redemption-hint": "Total number of Rewards generated in the period",
      "total-spent": "Generated turnover",
      "total-spent-hint": "Total turnover generated by the offer over the period",
      "total-to-pay": "Total to pay",
      "transaction": "Transaction",
      "transactions": "Transactions",
      "type": "Type",
      "unique-details-views": "Committed customers",
      "unique-details-views-hint": "Number of customers who clicked on this offer",
      "unique-listing-views": "Customers reached",
      "unique-listing-views-hint": "Number of customers who saw this offer in a listing",
      "universe": "Universe",
      "universes": "Universes",
      "username": "Username",
      "visitors": "visitors",
      "website": "Website",
      "zipcode": "Zip code",
      "value": "Value",
      "objective": "Objective"
    },
    "widget": {
      "remaining-chars": "Remaining characters: { number }",
    },
    "button": {
      "add": "Add",
      "force-sync": "Synchronize",
      "download": "Download",
      "visit-site": "Visit the website",
      "lock-again": "Lock again",
      "unlock": "Unlock",
      "accept": "Accept",
      "send-test": "Send test",
      "back": "Back",
      "cancel": "Cancel",
      "clipboard": "Clipboard",
      "close": "Close",
      "confirm": "Confirm",
      "contact-support": "Contact support",
      "copy": "Copy",
      "create": "Create",
      "download-logo": "Download logo",
      "download-visual": "Download visual",
      "edit": "Edit",
      "export": "Export",
      "import": "Import",
      "invite": "Invite",
      "know-more": "Know more",
      "load": "Load",
      "modify": "Modify",
      "next": "Next",
      "ok": "Ok",
      "open": "Open",
      "prev": "Previous",
      "publish": "Publish",
      "refresh": "Refresh",
      "reject": "Reject",
      "save": "Save",
      "search": "Search",
      "send": "Send",
      "simulate": "Simulate",
      "start-again": "Start again",
      "terms-hide": "Hide terms",
      "terms-show": "Display terms",
      "update": "Update",
      "select": "Select"
    },
    "granularity": {
      "no_reset": "No reset",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "quarterly": "Quarterly",
      "biannual": "Biannual",
      "yearly": "Yearly",
    },
    "date": {
      "d": "d",
      "days": "days",
      "hours": "hours",
      "minutes": "minutes",
      "seconds": "seconds",
      "period": {
        "this-month": "This month",
        "last-month": "Last month",
        "6-months": "6 months",
        "this-year": "This year",
        "last-year": "Last year",
        "lifetime": "Lifetime",
      },
      "ago": {
        "seconds": "a few seconds ago",
        "minutes": "{minutes, plural, =1 {a minute} other {# minutes}} ago",
        "hours": "{hours, plural, =1 {an hour} other {# hours}} ago",
        "days": "{days, plural, =1 {a day} other {# days}} ago",
        "months": "{months, plural, =1 {a month} other {# months}} ago",
        "years": "{years, plural, =1 {a year} other {# years}} ago",
      },
      "day": {
        "0": "Sunday",
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday",
      },
      "day-short": {
        "0": "Sun.",
        "1": "Mon.",
        "2": "Tue.",
        "3": "Wed.",
        "4": "Thur.",
        "5": "Fri.",
        "6": "Sat.",
      },
      "month": {
        "0": "January",
        "1": "February",
        "2": "March",
        "3": "April",
        "4": "May",
        "5": "June",
        "6": "July",
        "7": "August",
        "8": "September",
        "9": "October",
        "10": "November",
        "11": "December"
      },
      "month-short": {
        "0": "Jan.",
        "1": "Feb.",
        "2": "Mar.",
        "3": "Apr.",
        "4": "May",
        "5": "June",
        "6": "July",
        "7": "Aug.",
        "8": "Sept.",
        "9": "Oct.",
        "10": "Nov.",
        "11": "Dec.",
      },
    },
    "operator": {
      "SUM": "Sum",
      "AVG": "Average",
      "MIN": "Min",
      "MAX": "Max",
    },
    "target": {
      "types": {
        "BRAND": "Purchase from brands",
        "PURCHASE_AMOUNT": "Purchase amount",
        "PURCHASE_COUNT": "Purchase count",
        "PURCHASE_FIRST_DATE": "First purchase date",
        "PURCHASE_FIRST_MONTHS": "Time since first purchase",
        "PURCHASE_LAST_DATE": "Last purchase date",
        "MONTHS_SINCE_LAST_PURCHASE": "Time since last purchase",
        "REWARD_COUNT": "Number of cashback earned",
      },
      "operators": {
        'AND': 'And',
        'OR': 'Or',
        "=": "Equal to ",
        "!=": "Not equal to",
        "<": "Lower than",
        "<=": "Lower than or equal to",
        ">": "Greater than",
        ">=": "Greater than or equal to",
      },
      "counts": {
        "months": "{ nb, plural, =0 {never} =1 {# month} other {# months} }",
        "last-months": "{ nb } { period, plural, =0 {Jamais} =1 {in the last month} other {in the last # months} }",
        "date-range": "{ nb } from { start_date } to { end_date }"
      },
      "prefix": {
        "campaign": "From campaign"
      }
    },
    "countries": countryList,
    "password": {
      "length": "Minimum 14 characters",
      "lowercase": "1 lowercase",
      "uppercase": "1 uppercase",
      "digit": "1 digit",
      "special": "1 special",
      "no_username": "No username (firstname or lastname)",
      "no_product": "No company name or one of our product names",
    },

    "notification": {
      "new_strategy_exposed_to_program_manager": {
        "title": "New campaign available",
        "hint": "Receive an email notification when a new campaign is available",
      },
      "strategy_soon_completed": {
        "title": "Campaign ending soon",
        "hint": "Receive an email notification when a campaign is ending soon (scheduled end date)",
      },
      "strategy_end_date_extended": {
        "title": "Campaign extension",
        "hint": "Receive an email notification when a campaign is extended (new end date)",
      },
      "strategy_end_date_shortened": {
        "title": "Campaign shortened",
        "hint": "Receive an email notification when a campaign is shortened (new end date)",
      },
      "strategy_new_illustrations_available": {
        "title": "New visual available",
        "hint": "Receive an email notification when new visuals are available",
      },
      "strategy_new_phase_created": {
        "title": "Boosted rate phase available",
        "hint": "Receive an email notification when a new boosted rate phase is available",
      }
    }
  },
};
